<img class="article-image"  [src]="showControls && images && images.length ? images[currentImageIndex] : imageUrl" [attr.loading]="useLazyLoad ? 'lazy' : undefined"  [alt]="description"
  [ngClass]="classList" (click)="imageClick.emit($event)" [attr.width]="width ? width : undefined"  [attr.height]="height ? height : undefined" (error)="handleMissingImage($event)">
<ng-content></ng-content>
@if (showControls && images && images.length > 1) {
  <i class="material-icons img-control prev clickable withOpacity" (click)="previousImage()">keyboard_arrow_left</i>
  <i class="material-icons img-control next clickable withOpacity" (click)="nextImage()">keyboard_arrow_right</i>
}

